import axios from 'axios';
import {
  EUserProvider,
  TGetFriendStatusBody,
  TGetFriendStatusBySessionTokenBody,
  TGetFriendStatusResponse,
  TLineLinkResponse,
  TLineOAuthTokenBody,
  TLineOAuthTokenResponse,
  TPrepareSignedLineOAuthStateBody,
  TPrepareSignedLineOAuthStateResponse,
  TSendLineChatMessage,
} from 'types';

const exchangeLineAuthCodeForToken = async (
  body: TLineOAuthTokenBody,
): Promise<TLineOAuthTokenResponse> => {
  const response = await axios.post('/line/oauth/token', {
    ...body,
    applicationProvider: EUserProvider.MALE_APPLICATION,
  });
  return response.data;
};
      
const prepareSignedLineOAuthState = async (
  body: TPrepareSignedLineOAuthStateBody,
): Promise<TPrepareSignedLineOAuthStateResponse> => {
  const response = await axios.post('/line/oauth/prepare-signed', body);
  return response.data;
};

const getLinkLineBotAccount = async (
  basicId: string,
): Promise<{ basicId: string }> => {
  const response = await axios.post('/line/male/link-account', { basicId });
  return response.data;
};

const getFriendStatusBySessionToken = async (
  payload: TGetFriendStatusBySessionTokenBody,
): Promise<TGetFriendStatusResponse> => {
  const response = await axios.post('/line/session/friend-status', payload);
  return response.data;
};

const getFriendStatusByLineUserId = async (
  payload: TGetFriendStatusBody,
): Promise<TGetFriendStatusResponse> => {
  const response = await axios.post(`/line/friend-status`, payload);
  return response.data;
};

const getLineConnectionUrl = async (
  linkToken: string,
): Promise<TLineLinkResponse> => {
  const response = await axios.get('/line/male/link', {
    params: { linkToken },
  });
  return response.data;
};

const sendLineChatMessage = async (body: TSendLineChatMessage) => {
  const response = await axios.post('/line/send/chat-message', body);
  return response.data;
};

const toggleInactiveLine = async (
  inactiveLine: boolean,
): Promise<{ isHasFriend?: boolean }> => {
  return await axios
    .patch('line/male/toggle', { inactiveLine })
    .then((response) => {
      return response.data;
    });
};

export {
  getLineConnectionUrl,
  getFriendStatusBySessionToken,
  getFriendStatusByLineUserId,
  sendLineChatMessage,
  toggleInactiveLine,
  getLinkLineBotAccount,
  exchangeLineAuthCodeForToken,
  prepareSignedLineOAuthState,
};
